export default {
    default: 'default',
    red:     'red',
};